import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useNavigationState } from "@/zustand/NavigationState";

export function useStartPaymentsFaqView() {
  const startPaymentsFaqView = useNavigationState(
    (s) => s.startPaymentsFaqView,
  );
  const navigate = useNavigate();

  return useCallback(() => {
    startPaymentsFaqView();
    navigate("/");
  }, [startPaymentsFaqView, navigate]);
}
